import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { CONSTANTS } from '../../constants/constants';
import { EventConfig, getEventConfig } from '../../constants/event-config';
import { Option } from '../inputs/select/options';
import { ActivatedRoute } from '@angular/router';
import {
  EventRegistrationService,
  OrderSummary,
} from '../../services/event-registration.service';
import { PaymentService } from '../../services/payment.service';

@Component({
  selector: 'app-event-registration-form',
  templateUrl: './event-registration-form.component.html',
  styleUrls: ['./event-registration-form.component.scss'],
})
export class EventRegistrationFormComponent implements OnInit {
  event: any;
  eventConfig: EventConfig | null;

  public genderOptions: Option[] = CONSTANTS.GENDER_OPTIONS;

  public openStates = {
    general: true,
    race_details: false,
  };

  public groupOptions: Option[] | null;

  public innerForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private eventRegistrationService: EventRegistrationService,
    private paymentService: PaymentService
  ) {}

  ngOnInit(): void {
    this.event = this.route.snapshot.data['event'];
    this.eventConfig = getEventConfig(this.event.event_id);
    this.groupOptions = this.eventConfig?.groupOptions || null;
    this.initForm();
    this.innerForm.valueChanges.subscribe((value) => {
      this.eventRegistrationService.updateOrderSummary(
        this.event.event_id,
        value
      );
    });
    setTimeout(() => {
      this.innerForm.updateValueAndValidity();
    });
    this.paymentService.getPaymentMethods().subscribe();
  }

  initForm(): void {
    this.innerForm = this.formBuilder.group({
      general: this.formBuilder.group({
        first_name: ['', [Validators.required]],
        last_name: ['', [Validators.required]],
        gender: ['', [Validators.required]],
        year_of_birth: ['', [Validators.required]],
        email: ['', [Validators.required]],
        phone: ['', [Validators.required]],
      }),
      race_details: this.formBuilder.group({
        team: ['', [Validators.required]],
        group: [this.groupOptions?.[0].id, [Validators.required]],
        licenceUrl: ['', [Validators.required]],
      }),
    });
  }

  register(): void {
    this.paymentService
      .makePayment(
        this.eventRegistrationService.orderSummary as OrderSummary,
        this.innerForm.get('general.email')?.value
      )
      .subscribe((res: any) => {
        window.location.href = res.checkout_url;
      });
  }
}
